import { Grid } from '@mui/material';
import { SwitchInput } from '../../../../components/switchInput/SwitchInput';
import './stepLegales.scss';

const StepLegales = ({ stepsData, setStepsData }) => {

  const handleToggle = (e) => {
    const { checked, name } = e.target;
    setStepsData(previousData => ({
      ...previousData,
      documentoLegales: {
        ...previousData.documentoLegales,
        [name]: checked
      }
    }));
  }

  return (
    <div className='plan-cuidado-step-legales'>
      <Grid
        container
        columns={{
          xs: 2,
          md: 8
        }}
        spacing={2}
      >
        <Grid size={{ xs: 2, md: 1.3 }}>
          <div className='switch-row'>
            <span>Bloquea envio</span>
            <SwitchInput
              onChange={handleToggle}
              name='bloqueaEnvio'
              checked={stepsData?.documentoLegales?.bloqueaEnvio}
            />
          </div>
        </Grid>
        <Grid size={{ xs: 2, md: 2 }}>
          <div className='switch-row'>
            <span>Fecha de firma bloquea inicio</span>
            <SwitchInput
              onChange={handleToggle}
              name='firmaBloqueaInicio'
              checked={stepsData?.documentoLegales?.firmaBloqueaInicio}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default StepLegales





